import type { FrequencyValue } from '@/constants/Frequency';
import type { OptionProps } from '@amelio/ui-library';

import { Frequency } from '@/constants/Frequency';
import i18n from '@/plugins/i18n';

export const getFrequencyLabel = (frequency: FrequencyValue): string => {
    switch (frequency) {
        case Frequency.UPON_REQUEST:
            return i18n.t('frequency.uponRequest');
        case Frequency.EVERY_WEEK:
            return i18n.t('frequency.everyWeek');
        case Frequency.EVERY_TWO_WEEKS:
            return i18n.t('frequency.everyTwoWeeks');
        case Frequency.EVERY_FOUR_WEEKS:
            return i18n.t('frequency.everyFourWeeks');
        case Frequency.EVERY_SIX_WEEKS:
            return i18n.t('frequency.everySixWeeks');
        case Frequency.EVERY_EIGHT_WEEKS:
            return i18n.t('frequency.everyEightWeeks');
        case Frequency.EVERY_TWELVE_WEEKS:
            return i18n.t('frequency.everyTwelveWeeks');
        case Frequency.EVERY_SEMESTER:
            return i18n.t('frequency.everySemester');
        case Frequency.EVERY_YEAR:
            return i18n.t('frequency.everyYear');
        default:
            return frequency;
    }
};

export const getFrequencyOptions = (): OptionProps[] => {
    return Object.values(Frequency).map((frequency) => ({
        value: frequency,
        label: getFrequencyLabel(frequency),
    }));
};
